import { curry, insert, remove, nth } from 'ramda';
export default curry((at, to, list) => insert(to, nth(at, list), remove(at, 1, list)));
//# sourceMappingURL=changeArrayItemIndex.js.map